<template>
  <div
    class="conditionFilter"
    v-if="addPurchaseSift && Object.keys(addPurchaseSift).length > 0"
  >
    <template v-for="(value, key, index) in addPurchaseSift">
      <select-row
        v-if="addPurchaseSift && addPurchaseSift[key] && index < 3"
        :key="index"
        :data="value"
        :type="key"
        :label="filterName[key]"
        @input="controler"
      ></select-row>
    </template>
    <template v-for="(value, key, index) in addPurchaseSift">
      <select-row
        v-if="addPurchaseSift && addPurchaseSift[key] && index > 2 && isShowMore"
        :key="index"
        :data="value"
        :type="key"
        :label="filterName[key]"
        @input="controler"
      ></select-row>
    </template>
  </div>
</template>

<script>
import SelectRow from './SelectRow'
import { mapState } from 'vuex'
// import types from '../store/types'
// import { localStorage } from '@/util/storage'

export default {
  name: 'condition-filter',
  componentName: 'ConditionFilter',
  props: ['isShowMore'],
  data() {
    return {
      grades: null,
      subjects: null,
      difficulties: null,
      terms: null, // 全部
      timeSlots: null,
      timeTypes: null // 全部
    }
  },
  components: { SelectRow },
  computed: {
    ...mapState({
      filterName: state => state.AddPurchase.filterName,
      addPurchaseSift: state => state.AddPurchase.addPurchaseSift,
      breadFilItem: state => state.AddPurchase.breadFilItem
    }),
    filterList() {
      return [
        { type: 'grades', value: this.grades, prop: 'grades' },
        { type: 'subjects', value: this.subjects, prop: 'subjects' },
        { type: 'difficulties', value: this.difficulties, prop: 'difficulties' },
        { type: 'terms', value: this.terms, prop: 'terms' },
        { type: 'timeTypes', value: this.timeTypes, prop: 'timeTypes' },
        { type: 'timeSlots', value: this.timeSlots, prop: 'timeSlots' },
        { type: 'courseTypes', value: this.timeSlots, prop: 'courseTypes' },
        { type: 'textbookContents', value: this.timeSlots, prop: 'textbookContents' },
        { type: 'versions', value: this.timeSlots, prop: 'versions' },
        { type: 'studyPhases', value: this.timeSlots, prop: 'studyPhases' },
        { type: 'progresse', value: this.timeSlots, prop: 'progresse' },
        { type: 'times', value: this.timeSlots, prop: 'times' },
        { type: 'knowledges', value: this.timeSlots, prop: 'knowledges' },
        { type: 'labels', value: this.timeSlots, prop: 'labels' }
      ]
    },
    showConditionFilter() {
      for (let key in this.searchFilter) {
        if (
          this.searchFilter[key] &&
          this.searchFilter[key].length > 0 &&
          this.showSearchFilter[key] === true
        ) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    // 点击筛选项，更新路由
    async controler(data, event) {
      this.updataRoute(data, event)
    },
    async updataRoute(data, event) {
      // data 包括点击项的类型和所有信息
      const routeInfo = await this.routeInfo(data)
      const dealBread = this.dealBreadFilItem()
      if (dealBread) {
        const newRouteQuery = Object.assign({}, routeInfo.query, dealBread)
        const newRouteInfo = { name: 'add-purchase', query: newRouteQuery }
        this.xesLog('click', data, newRouteInfo, event)
        this.$router.replace(newRouteInfo)
      } else {
        this.xesLog('click', data, routeInfo, event)
        this.$router.replace(routeInfo)
      }
    },
    // 将选中的选项放入 route中，并隐藏该筛选项，在面包屑中暴露该选项
    async routeInfo(data) {
      const currentQuery = {}
      // 保存路由更改之前的项
      const { query } = this.$route
      const key = data.type
      currentQuery[key] = data.data.id
      currentQuery.flag = 2 // 改变原始页面了
      return {
        name: 'add-purchase',
        params: this.$route.params,
        query: { ...query, ...currentQuery }
      }
    },
    queryStr(obj) {
      // 日志
      let arr = []
      for (let key in obj) {
        arr.push([key, obj[key]])
      }
      const query = encodeURIComponent(arr.map(item => item.join('=')).join('&'))
      return '?' + query
    },
    xesLog(eventName, data, routeInfo, event) {
      const {
        grades = '',
        subjects = '',
        difficulties = '',
        terms = '',
        timeTypes = '',
        timeSlots = ''
      } = routeInfo.query
      const queryStr = this.queryStr(routeInfo.query)
      const clickURL = this.computedURL(`/add-purchase/${queryStr}`)
      const clickIdTypes = {
        grades: '1.5.5',
        subjects: '1.5.6',
        difficulties: ' 1.5.7',
        terms: '1.5.8',
        timeTypes: '1.5.9',
        timeSlots: '1.5.10'
      }
      const clickId = clickIdTypes[data.type]
      const XESLog = new this.$XESLog({
        key: `xeslog-addPurchaseSift-${data.type}`,
        courseid: this.$route.params.courseId,
        gradeid: grades && Number(grades),
        subjectid: subjects && Number(subjects),
        timeslotids: timeSlots && Number(timeSlots),
        difficultids: difficulties && Number(difficulties),
        termids: terms && Number(terms),
        timeids: timeTypes && Number(timeTypes),
        clickurl: clickURL,
        itemid: data.data.id,
        clickid: clickId
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    },
    dealBreadFilItem() {
      if (this.breadFilItem) {
        const newObj = {}
        for (let key in this.breadFilItem) {
          newObj[key] = this.breadFilItem[key].id
        }
        return newObj
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.conditionFilter {
  background: #fff;
  padding: 8px 28px;
  font-size: 13px;
}
.show-more-btn {
  position: relative;
  height: 22px;
  .siftMore {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 77px;
    height: 22px;
    color: #999999;
    font-size: 12px;
    border: solid 1px #cccccc;
    cursor: pointer;
    padding: 0 8px;
    box-sizing: border-box;
    span {
      display: inline-block;
      vertical-align: middle;
      line-height: 20px;
    }
    img {
      display: inline-block;
      margin-left: 3px;
      vertical-align: middle;
      width: 8px;
      height: 5px;
      transition: all 0.2s;
    }
    .rotate {
      transform: rotate(180deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/AddPurchase/components/ConditionFilter.vue